import type { Geo } from './types';

export const geo: Geo = {
  districts: [
    {
      id: "songino", ko: "송기노하이르항구", mn: "Сонгинохайрхан",
      count: 27, active: 9, arrest: 14, top: "meth",
      points: "60,90 250,90 250,300 150,340 60,330",
      cx: 150, cy: 205,
    },
    {
      id: "bayangol", ko: "바양골구", mn: "Баянгол",
      count: 14, active: 4, arrest: 7, top: "cannabis",
      points: "250,210 360,210 360,320 250,300",
      cx: 305, cy: 262,
    },
    {
      id: "chingeltei", ko: "칭겔테이구", mn: "Чингэлтэй",
      count: 16, active: 5, arrest: 8, top: "cannabis",
      points: "250,75 385,75 385,210 250,210",
      cx: 318, cy: 145,
    },
    {
      id: "sukhbaatar", ko: "수흐바타르구", mn: "Сүхбаатар",
      count: 11, active: 3, arrest: 5, top: "mdma",
      points: "385,75 540,75 540,215 385,210",
      cx: 462, cy: 145,
    },
    {
      id: "bayanzurkh", ko: "바양주르흐구", mn: "Баянзүрх",
      count: 34, active: 14, arrest: 22, top: "meth",
      points: "540,85 860,85 860,300 700,330 540,310 540,215",
      cx: 690, cy: 200,
    },
    {
      id: "khanuul", ko: "한울구", mn: "Хан-Уул",
      count: 21, active: 7, arrest: 11, top: "ketamine",
      points: "250,330 540,335 700,355 700,425 280,420",
      cx: 460, cy: 385,
    },
  ],
  hotspots: [
    { ko: "13구역 (바양주르흐)", mn: "Баянзүрх 13-р хороо", x: 650, y: 175, count: 18, sub: "meth" },
    { ko: "산사르", mn: "Сансар", x: 600, y: 240, count: 11, sub: "meth" },
    { ko: "톨고이트", mn: "Толгойт", x: 130, y: 160, count: 13, sub: "meth" },
    { ko: "6구역 (송기노)", mn: "Сонгино 6-р хороо", x: 195, y: 250, count: 9, sub: "cannabis" },
    { ko: "자이산", mn: "Зайсан", x: 470, y: 395, count: 8, sub: "ketamine" },
    { ko: "날라이흐", mn: "Налайх", x: 660, y: 390, count: 10, sub: "ketamine" },
    { ko: "3·4구역 (칭겔테이)", mn: "Чингэлтэй 3,4-р хороо", x: 320, y: 130, count: 7, sub: "cannabis" },
  ],
  routes: [
    { ko: "자민우드 국경 → 울란바토르", mn: "Замын-Үүд → Улаанбаатар", via: "육로 (АН-3)", count: 12, sub: "meth" },
    { ko: "알탄불라그 → 울란바토르", mn: "Алтанбулаг → Улаанбаатар", via: "육로 (АН-4)", count: 5, sub: "heroin" },
    { ko: "항공 (칭기스칸 공항)", mn: "Чингис Хаан НОБ", via: "항공 화물", count: 4, sub: "mdma" },
  ],
};
